import { Row, Container, Card, CardGroup } from 'react-bootstrap';

export default function HostsStats() {
  return (
    <Row>
      <Container className="pt-5 pb-5">
        <CardGroup>
          <Card border="light">
            <Card.Body>
              <Card.Title>Reach</Card.Title>
              <Card.Text className="display-3">1 Million +</Card.Text>
              <Card.Subtitle className="mb-2 text-muted">
                Potential Customers Per Trip*
              </Card.Subtitle>
            </Card.Body>
          </Card>

          <Card border="light">
            <Card.Body>
              <Card.Title>Get</Card.Title>
              <Card.Text className="display-3">100 +</Card.Text>
              <Card.Subtitle className="mb-2 text-muted">
                Bookings Per Trip*
              </Card.Subtitle>
            </Card.Body>
          </Card>
        </CardGroup>

        <p className="small m-2 text-muted font-italic">
          *The average host in 2019 reached over 1 million potential customers
          and sold over 170 spaces on their most popular trip.
        </p>
      </Container>
    </Row>
  );
}
